/**
 * Validates that a value is exactly equal to a given requirement.
 */
export const Validator = {
    name: "exact",
    errorMessage: "This field should equal to :value.",
    validate: (value, requirement) => {
        if (typeof value !== "string") {
            return false;
        }
        return value.split(":").includes(requirement);
    },
};
